import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    color: ${props => props.theme.text};
    font-family: 'Roboto', sans-serif;
  }
  h1, h2, h3 {
    font-family: 'Montserrat', sans-serif;
  }

  h1 {
    font-size: 27px;
    font-weight: 800;
  }

  h2 {
    font-size: 21px;
    font-weight: 500;
  }

  h3 {
    font-size: 16px;
  }

  p {
    font-size: 18px;
    color: ${props => props.theme.disable};
  }

  ::-webkit-scrollbar {
    width: 0.5em;
  }
  
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 100vw;
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.body};
    background: ${props => props.theme.primary};
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.secondary};
  }
  
  @supports (scrollbar-color: red blue) {
    *{
        scrollbar-color: ${props => props.theme.primary} ${props => props.theme.body};
        scrollbar-width: thin;
    }
    .mobile {
      scrollbar-color: transparent;
      scrollbar-width: 0;
    }
  
  }
`